import React from "react";
import TwoColumnImage from "./fc-2-column-image";
import Clients from "./fc-clients";
import ContentBlock from "./fc-content-block";
import ContentWithImage from "./fc-content-with-image";
import FeaturedBlocks from "./fc-featured-blocks";
import Image from "./fc-image";
import MultiColumnContent from "./fc-multi-column-content";
import Partners from "./fc-partners";
import RegularContent from "./fc-regular-content";
import Team from "./fc-team";
import Video from "./fc-video";
import Numbers from "./fc-numbers";
import Logos from "./fc-logos";
import FcPricing from "./fc-pricing";
import FeaturesOverView from "./product/product-features-overview";
import FeatureVerticalTabs from "./product/features-vertical-tabs";
import DeploymentOptions from "./product/deployment-options";
import CallToAction from "./call-to-action";
import SectionHeader from "./product-section-header";
import FeatureOverview from "./product/feature-overview";
import FeaturedBlock from "./featured-block";
import HowItWorks from "./product-how-it-works";
import InAction from "./product-in-action";
import Technology from "./product-technology";
import Timeline from "./timeline";
import Faq from "./faq";

function FlexibleContent({ items }) {
  return (
    <>
      {items.map((node) => {
        console.log(node._type);
        switch (node._type) {
          case "fcPricing":
            return <FcPricing {...node} />;
          case `fc2ColumnImage`:
            return <TwoColumnImage {...node} />;
          case `fcClients`:
            return <Clients {...node} />;
          case `fcContentBlock`:
            return <ContentBlock {...node} />;
          case `fcContentWithImage`:
            return <ContentWithImage {...node} />;
          case `fcFeaturedBlocks`:
            return <FeaturedBlocks items={node.featuredBlocks} />;
          case `fcImage`:
            return <Image {...node} />;
          case `fcMultiColumnContent`:
            return (
              <MultiColumnContent
                {...node}
                slider={node?.title === "Testimonials" || false}
              />
            );
          case `fcPartners`:
            return <Partners {...node} />;
          case `fcRegularContent`:
            return <RegularContent {...node} />;
          case `fcTeam`:
            return <Team {...node} />;
          case `fcVideo`:
            return <Video {...node} />;
          case `fcNumbers`:
            return <Numbers items={node.numbers} />;
          case `fcLogos`:
            return <Logos {...node} />;
          case "productFeaturesNew":
            return node.verticalTabs ? (
              <FeatureVerticalTabs {...node} />
            ) : (
              <FeaturesOverView {...node} />
            );
          case "deploymentOptions":
            return <DeploymentOptions {...node} />;
          case "productCallToAction":
            return <CallToAction {...node} />;
          case "captionTitleText":
            return (
              <SectionHeader
                title={node.title}
                position={node.position}
                subtitle={node.caption}
                description={node._rawDescription}
                greenBackground
              />
            );
          case "featureOverview":
            return <FeatureOverview {...node} />;
          case "featuredBlock":
            return <FeaturedBlock {...node} />;
          case "productHowItWorks":
            return <HowItWorks {...node} />;
          case "productInAction":
            return <InAction {...node} />;
          case "productTechnology":
            return <Technology {...node} />;
          case "timeline":
            return <Timeline {...node} />;
          case "faq":
            return <Faq {...node} />;
          default:
            return null;
        }
      })}
    </>
  );
}

export default FlexibleContent;
